import React from 'react'
import { JOIN_RULES } from '../data/communities_data'

const CommunityJoinRules = ({ value, onChange }) => (
  <div className="communityJoinRules">
    <p className="communityJoinRulesLabel">When a new member asks to join</p>
    {JOIN_RULES.map((rule) => (
      <button
        type="button"
        key={rule.id}
        className={`communityJoinRule${value === rule.id ? ' isOn' : ''}`}
        onClick={() => onChange(rule.id)}
      >
        <strong>{rule.label}</strong>
        <span>{rule.text}</span>
      </button>
    ))}
  </div>
)

export default CommunityJoinRules
